export const PaymentPeriod = {
    ANNUAL: "annually",
    MONTHLY: "monthly",
} as const;

export type PaymentPeriod = (typeof PaymentPeriod)[keyof typeof PaymentPeriod];
